export const CATERING_PT_BR = {
	title: "Catering",
	description:
		"Gerencie o catering dos seus eventos, receba propostas, envie orçamentos e monitore tudo em um lugar.",
	createProposal: "Criar proposta",
	createProposalMenu: {
		new: "Nova",
		fromTemplate: "A partir de um modelo",
	},
	proposalsList: {
		filters: {
			searchPlaceholder: "Buscar por nome do representante ou responsável pelo envio",
			statusPlaceholder: "Todos os status",
		},
		actions: {
			ariaLabel: "Ações da proposta",
			viewEdit: "Ver / Editar proposta",
			view: "Ver proposta",
			saveAsTemplate: "Salvar como modelo",
			download: "Baixar proposta",
			resend: "Reenviar proposta",
			delete: "Excluir",
		},
		confirmDelete: {
			title: "Excluir proposta",
			message:
				"Tem certeza que deseja excluir esta proposta? Esta ação não pode ser desfeita.",
			confirm: "Excluir",
		},
		feedback: {
			resendSuccess: "Proposta reenviada com sucesso.",
			downloadError: "Não foi possível baixar o PDF.",
			deleteSuccess: "Proposta excluída com sucesso.",
		},
	},
	createProposalPage: {
		title: "Nova proposta",
		saveAndAdvance: "Salvar e avançar",
		sidebarSummary: {
			client: "Cliente",
			duration_one: "{{count}} dia de duração",
			duration_other: "{{count}} dias de duração",
			totalLabel: "Investimento total",
			servicesCount_one: "{{count}} serviço",
			servicesCount_other: "{{count}} serviços",
			perParticipant: "{{value}} por participante",
			perDay: "{{value}} por dia",
		},
		notifications: {
			createSuccess: "Proposta criada com sucesso!",
			updateSuccess: "Proposta atualizada com sucesso!",
		},
		steps: {
			requestDetails: {
				label: "Detalhes da Solicitação",
				action: "Identifique a proposta",
				title: "Detalhes da Solicitação",
				description: "Digite as informações de identificação do solicitante da proposta.",
				fields: {
					name: {
						label: "Nome da proposta",
						placeholder: "Digite o nome da proposta",
					},
					observation: {
						label: "Observação (opcional)",
						placeholder: "Ex.: Contratação mínima de 50 pax.",
						counter: "{{count}}/{{max}} caracteres",
					},
					companyName: {
						label: "Empresa solicitante",
						placeholder: "Digite o nome da empresa / cliente",
					},
					representativeName: {
						label: "Representante da empresa",
						placeholder: "Digite o nome do representante",
					},
					eventPeriod: {
						label: "Período de realização do evento",
						placeholder: "DD/MM/AA - DD/MM/AA",
					},
				},
				validation: {
					name: { required: "Informe o nome da proposta" },
					companyName: { required: "Informe a empresa solicitante" },
					representativeName: { required: "Informe o representante da empresa" },
					eventPeriod: {
						required: "Informe o período do evento",
						future: "As datas precisam ser futuras",
						endBeforeStart: "A data final precisa ser maior ou igual à inicial",
					},
					observation: { max: "Máximo de {{max}} caracteres" },
				},
			},
			services: {
				label: "Serviços",
				action: "Adicione serviços e produtos",
				title: "Serviços",
				description: "Adicione as informações do serviço e produtos incluídos.",
				priceUpdates: {
					alert: {
						title: 'Proposta criada a partir do modelo "[Nome do modelo]".',
						message:
							"Alguns preços foram atualizados desde que este modelo foi salvo. Revise os valores antes de enviar.",
						link: "Ver produtos alterados",
					},
					modal: {
						title: "Produtos atualizados",
						intro:
							"Alguns produtos tiveram seus preços alterados desde a criação desta proposta modelo. Revise os valores antes de enviar.",
						sectionTitle: "Produtos alterados",
						removed: "Produto removido",
						confirm: "Entendi",
					},
				},
				emptyState: {
					title: "Ainda não há serviços adicionados",
					description: "Utilize a barra de busca para encontrar produtos",
					action: "Adicionar",
				},
				list: {
					counter: "Serviços adicionados ({{count}})",
					add: "Adicionar",
					total: "Total {{value}}",
					totalCount: "/ {{count}} serviços",
					fallbackTitle: "Serviço",
					actions: {
						reorder: "Reordenar serviço",
						edit: "Editar",
						duplicate: "Duplicar",
						delete: "Excluir",
					},
					itemsCount: "{{count}} itens",
					periodsCount: "{{count}} períodos",
					notifications: {
						added: "Serviço adicionado",
						updated: "Serviço atualizado",
						removed: "Serviço excluído",
						duplicated: "Serviço duplicado",
					},
					confirmDelete: {
						title: "Excluir serviço",
						message:
							"Tem certeza que deseja excluir este serviço? Esta ação não pode ser desfeita.",
						messageWithName:
							'Tem certeza que deseja excluir "{{name}}"? Esta ação não pode ser desfeita.',
						confirm: "Excluir",
					},
				},
				drawer: {
					title: "Novo serviço",
					editTitle: "Editar serviço",
					steps: {
						info: { label: "Informações" },
						products: { label: "Produtos" },
					},
					actions: {
						advance: "Avançar",
						back: "Voltar",
						save: "Salvar",
						summary: "{{count}} itens",
					},
					products: {
						title: "Adicione produtos",
						searchPlaceholder: "Buscar um produto ou combo",
						perPax: "/pax",
						empty: "Nenhum produto encontrado.",
						minSelectionError: "É necessário selecionar ao menos 1 produto",
						scrollPrev: "Categorias anteriores",
						scrollNext: "Próximas categorias",
						categories: {
							all: "Tudo",
							food: "Alimentos",
							drink: "Bebidas",
							combo: "Combos",
						},
					},
					mountable: {
						title: "Escolha as opções",
						sectionCounter: "{{current}} de {{max}}",
						confirm: "Adicionar",
						remove: "Remover",
						confirmRemove: {
							title: "Remover combo do serviço?",
							message: "As seleções deste combo serão descartadas.",
							confirm: "Remover",
						},
					},
					info: {
						title: "Insira as informações do novo serviço",
						fields: {
							name: {
								label: "Nome do grupo (opcional)",
								placeholder: "Ex.: Catering 1",
							},
							serviceType: {
								label: "Tipo de serviço",
								placeholder: "Selecione",
							},
							serviceFormat: {
								label: "Formato",
								placeholder: "Selecione",
							},
							numberOfPeople: {
								label: "Quantidade de pessoas",
								placeholder: "00",
							},
							location: {
								label: "Local ou stand",
								placeholder: "Ex. 'Sala 5'",
							},
							periodMode: {
								label: "Adicionar horário por",
								datetime: "Data e hora",
								duration: "Duração",
							},
							dates: {
								label: "Datas",
								placeholder: "DD/MM/AAAA",
							},
							startTime: {
								label: "Horário Inicial",
								placeholder: "00:00",
							},
							endTime: {
								label: "Horário Final",
								placeholder: "00:00",
							},
							period: {
								add: "Adicionar período",
								removeAria: "Remover período {{index}}",
							},
							duration: {
								label: "Horário",
								placeholder: "00",
								unitLabel: "Unidade",
								units: {
									minutes: "Minutos",
									hours: "Horas",
								},
							},
							notes: {
								label: "Observação (opcional)",
								placeholder: "Ex.: Não pode conter frituras ou embutidos.",
							},
						},
						validation: {
							serviceTypeId: { required: "Selecione o tipo de serviço" },
							serviceFormatId: { required: "Selecione o formato" },
							numberOfPeople: { required: "Informe a quantidade de pessoas" },
							location: { required: "Informe o local ou stand" },
							duration: { required: "Informe a duração" },
							period: {
								invalidTime: "Horário inválido",
								endBeforeStart: "Deve ser maior ou igual ao início",
								dateRequired: "Informe a data",
							},
							notes: { max: "Máximo de {{max}} caracteres" },
						},
					},
				},
			},
			sendInfo: {
				label: "Informações de envio",
				action: "Revisar e enviar proposta",
				title: "Revisar e enviar proposta",
				description: "Revise sua proposta e envie para o cliente.",
				submit: "Revisar e enviar",
				previewEmail: "Pré-visualizar e-mail",
				confirm: {
					title: "Revise antes de confirmar o envio",
					clientLabel: "Cliente",
					eventStart: "{{date}} início",
					daysTotal_one: "{{count}} dia total",
					daysTotal_other: "{{count}} dias totais",
					investmentLabel: "Investimento total",
					productsCount_one: "{{count}} produto",
					productsCount_other: "{{count}} produtos",
					perParticipantSuffix: "por participante",
					perDaySuffix: "por dia",
					discountBadge: "Desconto de {{value}}",
					additionBadge: "Adicional de {{value}}",
					attachmentSize: "974.91 KB",
					attachmentName: "Orçamento {{proposalName}}.pdf",
					saveAsTemplate: "Salvar como modelo",
					cancel: "Cancelar",
					send: "Enviar proposta",
					sendSuccess: "Proposta enviada com sucesso!",
					downloadPdf: "Baixar PDF",
					sending: {
						pdf: "Gerando PDF...",
						email: "Enviando e-mail...",
					},
					error: {
						title: "Não foi possível gerar o PDF.",
						cta: "Tente novamente",
						retry: "Tentar novamente",
						backToDraft: "Voltar ao rascunho",
					},
				},
				preview: {
					title: "Revise antes de confirmar o envio",
					back: "Voltar",
					subject: "Seu orçamento de catering chegou",
					attachmentSize: "974.91 KB",
					attachmentName: "Orçamento {{proposalName}}.pdf",
					replyCta: "Responder proposta",
					signOff: "Atenciosamente,",
					signatureFallback: "Equipe",
				},
				fields: {
					totalValue: "Valor total",
					adjustment: {
						toggle: "Aplicar desconto ou adicional",
						valueLabel: "Valor",
						valuePlaceholder: "R$ 0,00",
						discount: "Desconto",
						addition: "Adicional",
					},
					mainEmail: {
						label: "E-mail principal para envio",
						placeholder: "maria@email.com",
						tooltip: "E-mail principal do cliente que receberá a proposta.",
					},
					ccEmails: {
						label: "E-mails em cópia",
						placeholder: "maria@email.com, joao@email.com",
						tooltip: "Separe múltiplos e-mails por vírgula.",
					},
					validUntil: {
						label: "Validade da proposta",
						placeholder: "DD/MM/AAAA",
					},
					bodyText: {
						label: "Texto do corpo do e-mail",
						placeholder: "Ex.: Olá! Segue o orçamento como solicitado.",
						counter: "caracteres",
					},
				},
				validation: {
					adjustment: {
						value: {
							required: "Informe o valor",
							min: "O valor deve ser maior que zero",
						},
						type: { required: "Selecione o tipo de ajuste" },
					},
					mainEmail: {
						required: "Informe o e-mail principal",
						invalid: "E-mail inválido",
					},
					ccEmails: { invalid: "Um ou mais e-mails inválidos" },
					validUntil: {
						required: "Informe a validade da proposta",
						future: "A data precisa ser futura",
					},
					bodyText: { max: "Máximo de {{max}} caracteres" },
				},
			},
		},
	},
	proposalDetailPage: {
		proposalLabel: "Proposta #{{id}}",
		status: {
			newResponse: "NOVA RESPOSTA",
		},
		actions: {
			copyLink: "Copiar link",
			favorite: "Favoritar",
		},
		sidebar: {
			historyTab: "Histórico",
			clientLabel: "Cliente",
			investmentTotal: "Investimento total",
			sendInfoPlaceholder: "Resumo do envio",
			stepLabels: {
				history: "Histórico",
				requestDetails: "Detalhes da Solicitação",
				services: "Serviços",
				sendInfo: "Envio",
			},
			durationDays_one: "{{count}} dia de duração",
			durationDays_other: "{{count}} dias de duração",
			servicesCount_one: "{{count}} serviço",
			servicesCount_other: "{{count}} serviços",
			perParticipantSuffix: "por participante",
			perDaySuffix: "por dia",
			startDateSuffix: "início",
		},
		history: {
			title: "Histórico",
			description: "Visualize sua conversa com o cliente.",
			firstReply: "Primeira resposta em {{date}} às {{time}}, {{weekday}}",
			sortAria: "Ordenar mensagens",
			loadError: "Não foi possível carregar o histórico.",
			message: {
				newTag: "NOVO",
				reply: "Responder",
				sendFailed: "FALHA NO ENVIO",
				resend: "Reenviar",
				downloadAria: "Baixar anexo",
			},
		},
		placeholder: "{{section}} em construção",
	},
};

export type CateringTranslations = typeof CATERING_PT_BR;
